import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";

import CoinTossPage from "./pages/CoinTossPage";
import NewTossPage from "./pages/NewTossPage";
import Home from "./pages/Home";
import BatOrBallWheelPage from "./pages/BatOrBallWheelPage";
import BatFlipPage from "./pages/BatFlipPage";
import CommentaryRevealPage from "./pages/CommentaryRevealPage";

const App: React.FC = () => (
  <ChakraProvider value={defaultSystem}>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/coin-toss" element={<CoinTossPage />} />
        <Route path="/coin-toss-new" element={<NewTossPage />} />
        <Route path="/wheel" element={<BatOrBallWheelPage />} />
        <Route path="/bat-flip" element={<BatFlipPage />} />
        <Route path="/commentary" element={<CommentaryRevealPage />} />
      </Routes>
    </Router>
  </ChakraProvider>
);

export default App;
